import { render } from "./CopyCatalogResponse.vue?vue&type=template&id=79933f27&scoped=true"
import script from "./CopyCatalogResponse.vue?vue&type=script&lang=js"
export * from "./CopyCatalogResponse.vue?vue&type=script&lang=js"

import "./CopyCatalogResponse.vue?vue&type=style&index=0&id=79933f27&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79933f27"]])

export default __exports__